import { Modal, Skeleton } from 'antd';
import { useGetImageUrl } from 'common/hooks';
import { useState } from 'react';
import pp from './user.png'
type propsType = {
  imgId: string;
  className: string;
  imgAlt?: string;
  onClick?: () => void;
  showSkeleton?: boolean;
  skeletonStyle?: string;
  isClickable?: boolean;
};
export const ImageComponent = ({
  imgId,
  className,
  imgAlt,
  onClick,
  showSkeleton = true,
  skeletonStyle,
  isClickable
}: propsType) => {
  const { imgUrl, isLoading } = useGetImageUrl(imgId);
  const [open, setOpen] = useState(false)
  return (
    <>
      {isLoading && showSkeleton ? (
        <div className={`${className} flex justify-center items-center`}>
          <Skeleton.Image active className={skeletonStyle} />
        </div>
      ) : (
        <img
          src={imgUrl ?? pp}
          alt={imgAlt || 'Img'}
          className={`${className} ${isClickable ? "cursor-pointer" : ""}`}
          onClick={() => {
            onclick
            isClickable && setOpen(true)
          }}
        />
      )}
      <Modal
        footer={null}
        open={open}
        onCancel={() => setOpen(false)}

      >
        <div className='flex justify-center mx-auto items-center max-h-[70vh] max-w-[400px] w-full'>
          <img
            src={imgUrl ?? pp}
            alt={imgAlt || 'Img'}
            className='w-full max-h-[350px] rounded-md object-contain'
          />
        </div>
      </Modal>
    </>
  );
};
